import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import useListAction from 'core/hooks/useListAction'
import { listFloatingIps } from './actions'
import { floatingIpsSelector } from './selectors'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function AvailableFloatingIpsPicklist({
  disabled = false,
  name = 'floatingIp',
  label = 'Public IP',
  portId = null,
  enableSearch = false,
  ...rest
}) {
  const { loading } = useListAction(listFloatingIps)
  const floatingIps = useSelector(floatingIpsSelector)

  // Unattached IPs, plus (when editing a port) the IPs already attached to that port so
  // its current selections still show up as options
  const availableFloatingIps = useMemo(() => {
    return floatingIps.filter((ip) => !ip.port_id || (portId && ip.port_id === portId))
  }, [floatingIps, portId])

  const options = useMemo(() => {
    return availableFloatingIps.map((ip) => ({
      label: `${ip.network?.name || ip.floating_network_id}: ${ip.floating_ip_address}`,
      value: ip.id,
    }))
  }, [availableFloatingIps])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={options}
      enableSearch={enableSearch}
    />
  )
}
